import styled, { css } from 'styled-components';

import { AutoComplete } from '@xingternal/auto-complete';
import { TextButton } from '@xingternal/button';
import { Label as LabelComponent } from '@xingternal/label';
import { mediaConfined, mediaSmallOrTiny, mediaWide } from '@xingternal/layout-tokens';
import { Menu } from '@xingternal/menu';
import { RadioButton as RadioButtonComponent } from '@xingternal/radio-button';
import {
  spaceL,
  spaceM,
  spaceS,
  xdlColorBackgroundTertiary,
  xdlColorBorder,
  xdlColorControlBorder,
  xdlColorDisabledSoft,
  xdlColorDisabledStrong,
  xdlColorHoverSecondary,
  xdlColorTextTertiary,
} from '@xingternal/tokens';
import { Hero as HeroComponent } from '@xingternal/typography';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;

  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceS};
  }
`;

export const Form = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;

  @media ${mediaWide} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const Hero = styled(HeroComponent)`
  width: 100%;
  flex: 100%;
  margin-bottom: 20px;

  @media ${mediaWide} {
    margin-top: ${spaceL};
  }
`;

export const KeywordsAutoComplete = styled(AutoComplete)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    width: 100%;
    flex: 1 1 0;
    margin-bottom: ${spaceL};
    margin-right: ${spaceS};
  }

  @media ${mediaWide} {
    margin-right: ${spaceL};
    margin-bottom: 0;
  }
`;

export const LocationFieldsButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 15%;
`;

export const LocationFieldsWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  margin-right: ${spaceS};

  @media ${mediaWide} {
    margin-right: ${spaceL};
  }
`;

export const LocationAutoComplete = styled(AutoComplete)`
  && {
    width: 100%;

    @media ${mediaConfined} {
      width: 50%;

      & ul {
        width: 200%;
      }

      & input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: 1px solid ${xdlColorControlBorder};
      }
    }
  }
`;

export const RadiusWrapper = styled.div`
  width: 50%;
  position: relative;
`;

const radiusButtonFilled = css`
  background-color: inherit;
  border: solid 1px ${xdlColorBorder};
  border-left: none;
`;

export const RadiusButton = styled(TextButton)<{ $isFilled: boolean }>`
  && {
    width: 100%;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    padding: 0 20px;
    background-color: ${xdlColorBackgroundTertiary};

    ${({ $isFilled }) => $isFilled && radiusButtonFilled}

    &:disabled {
      background-color: ${xdlColorDisabledSoft};
      border: none;

      & > div > :last-child {
        color: ${xdlColorDisabledStrong};
      }
    }

    &:active:not([disabled]) {
      ${radiusButtonFilled}
    }

    &:hover:not([disabled]) {
      background-color: ${xdlColorHoverSecondary};
      border: none;
    }

    & > div {
      width: 100%;
      justify-content: space-between;

      ${({ $isFilled }) =>
        !$isFilled &&
        css`
          & > :last-child {
            color: ${xdlColorTextTertiary};
          }
        `}
    }
  }
`;

export const RadiusMenu = styled(Menu)`
  min-width: 100%;
  white-space: nowrap;
`;

export const Label = styled(LabelComponent)`
  cursor: pointer;
`;

export const RadioButton = styled(RadioButtonComponent)`
  margin-right: ${spaceM};
`;
